<script setup>
import { defineProps, defineEmits } from 'vue';
import HeroIcon from '@/Components/UI/HeroIcon.vue';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false
  },
  customClasses: {
    type: String,
    default: ''
  },
  tooltip: String,
  icon: String,
  disabled: {
    type: Boolean,
    default: false
  },
  flat: {
    type: Boolean,
    default: false
  },
  hideLabelOnMobile: { // Nueva propiedad para controlar visibilidad en móvil
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['click']);

const handleClick = (event) => {
  if (props.disabled) {
    event.stopImmediatePropagation(); // Previene que se propague el evento
    return; // Salimos de la función si el botón está deshabilitado
  }

  emit('click', event); // Solo emite si no está deshabilitado
};

</script>

<template>
  <!-- Aquí las customClasses se aplican al final para sobrescribir las clases por defecto si es necesario -->
  <button :class="[
      'inline-flex items-center justify-center font-medium rounded-lg duration-150',
      // Si solo icono en móvil, quita paddings laterales en móvil
      hideLabelOnMobile ? 'p-2 sm:pl-2 sm:pr-4 sm:py-2' : 'pl-2 pr-4 py-2',
      'text-slate-400',
      customClasses,
      flat ? '' : 'border border-slate-400',
      disabled ? 'cursor-not-allowed text-slate-300' : 'bg-transparent hover:bg-slate-200 active:bg-slate-900'
    ]"
    :disabled="disabled"
    :aria-disabled="disabled.toString()"
    @click="handleClick"
  >
    <!-- Icono a la izquierda -->
    <HeroIcon v-if="icon" :iconName="icon" :tooltip="tooltip" class="ml-1" />
    <!-- Contenido del botón y el indicador de carga si está activo -->
    <span  v-if="$slots.default || loading" class="flex items-center" :class="{'ml-1': icon}">      <span v-if="loading" class="loading loading-spinner loading-xs mr-2"></span>
      <span 
        :class="{
          'hidden sm:inline': hideLabelOnMobile, // Oculta texto en móvil
          'truncate': true
        }"
      >
        <slot></slot>
      </span>
    </span>
  </button>
</template>
